<div class="info-wrapper">
  <div class="header" [ngClass]="{ 'no-toolbar': title === '' }">
    @if (title !== '') {
    <mat-toolbar class="page-top">
      @if (breadcrumbs.length > 0) {
      <mat-toolbar-row class="breadcrumb-row">
        @for (breadcrumb of breadcrumbs; track $index; let last = $last) {
        <div class="crumb">
          <a
            class="crumb-link"
            [attr.aria-current]="last ? 'page' : null"
            [id]="'link-nav-' + breadcrumb.label"
            [routerLink]="breadcrumb.link"
            [attr.title]="breadcrumb.label"
            >{{ breadcrumb.label }}</a
          >
          @if (!last) {
          <svg-icon class="crumb-chevron" src="/assets/images/icon-24-chevron-in2.svg"></svg-icon>
          }
        </div>
        }
      </mat-toolbar-row>
      }
      <mat-toolbar-row class="title-row">
        <div class="mat-headline-4">
          {{ title | translate }}
        </div>
        <span class="example-spacer"></span>
        <ng-content select="buttons"></ng-content>
      </mat-toolbar-row>
    </mat-toolbar>
    } @if (showNav) {
    <nav mat-tab-nav-bar [tabPanel]="tabPanel" [ngClass]="{ 'info-page-tabs': hasBorderBottom, 'grey-bg': true }">
      @for (link of links; track link.id) {
      <a
        mat-tab-link
        [id]="'link-tab-' + link.id"
        [routerLink]="link.path"
        (click)="setTabTitle(link.id)"
        [active]="activeLink === link.id"
      >
        {{ link.label | translate }}
      </a>
      }
    </nav>
    }
  </div>

  <mat-tab-nav-panel #tabPanel class="content-container" [attr.role]="showNav && links.length ? 'tabpanel' : null">
    <router-outlet></router-outlet>
    <ng-content></ng-content>
  </mat-tab-nav-panel>
</div>
